export const CATALOGS_STORE = 'catalogs/store';
export const CATALOGS_DESTROY = 'catalogs/destroy';

export default {
  CATALOGS_STORE,
  CATALOGS_DESTROY,
};
